import {
  URLAPI,
  TASK_TYPES_PATH,
  TASK_TYPE_CREATE_PATH,
  TASK_TYPE_UPDATE_PATH,
} from "../config/index";
import { LOGOUT } from './users'
import axios from "axios";

const init = {
  _get_all_task_types: {
    data: [],

    status: 0,
    message: {},
  },

  _create_task_type: {
    data: {},
    status: 0,
    message: {},
  },
  _update_task_type: {
    data: {},
    status: 0,
    message: {},
  },
};

const GET_ALL_TASK_TYPES = "GET_ALL_TASK_TYPES";
export const CREATE_TASK_TYPE = "CREATE_TASK_TYPE";
export const UPDATE_TASK_TYPE = "UPDATE_TASK_TYPE";

export const task_types_module = (state = init, action) => {
  switch (action.type) {
    case GET_ALL_TASK_TYPES:
      return {
        ...state,
        _get_all_task_types: action.payload,
      };
    case CREATE_TASK_TYPE:
      return {
        ...state,
        _create_task_type: action.payload,
      };
    case UPDATE_TASK_TYPE:
      return {
        ...state,
        _update_task_type: action.payload,
      };
    case LOGOUT:
      return init;
    default:
      return state;
  }
};

export const getAllTaskTypes = (token) => async (dispatch) => {
  try {
    const response = await axios.get(`${URLAPI}${TASK_TYPES_PATH}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    dispatch({
      type: GET_ALL_TASK_TYPES,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: GET_ALL_TASK_TYPES,
        payload: {
          data: [],
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: GET_ALL_TASK_TYPES,
        payload: {
          data: [],
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const createTaskType = (token, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.post(
      `${URLAPI}${TASK_TYPE_CREATE_PATH}`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: CREATE_TASK_TYPE,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: CREATE_TASK_TYPE,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: CREATE_TASK_TYPE,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const updateTaskType = (token, id, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.patch(
      `${URLAPI}${TASK_TYPE_UPDATE_PATH}${id}/`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_TASK_TYPE,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: UPDATE_TASK_TYPE,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: UPDATE_TASK_TYPE,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const clear_task_types = (type) => async (dispatch) => {
  dispatch({
    type: type,
    payload: {
      data: [],
      status: 0,
      message: {},
    },
  });
};
